// The whole AxiosError carries the request body and headers (passengers, tokens), so only these reach analytics.
const readSafeError = (error, path) => {
  if (!error) {
    return { path };
  }

  const safeError = {
    path,
    message: error.message,
    code: error.code,
    status: error.response && error.response.status,
    method: error.config && error.config.method,
    url: error.config && error.config.url,
  };
  return safeError;
};

export default readSafeError;
